import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import 'react-image-gallery/styles/css/image-gallery.css';
import ImageGallery from 'react-image-gallery';
import './NewsDetail.css';
import { getAllItems } from '../../services/JsonFetchService.js';
import { getFullDate } from '../../services/DateService.js';

function NewsDetail() {
  const id = useParams().id;
  const [newsItem, setNewsItem] = useState({
    paragraphs: [],
    photos: [],
    videos: [],
    title: '',
    date: '',
    mainImg: ''
  });

  useEffect(() => {
    async function fetchNewsItem() {
      const allNewsItems = await getAllItems('/news/newsItems.json');
      const currentNewsItem = allNewsItems.find(x => x.id === +id);
      setNewsItem(currentNewsItem);
    }

    fetchNewsItem();
  }, [id]);

  function getGalleryItems() {
    return newsItem.photos.map(x => {
      return { original: x }
    });
  };

  function hasPhotos() {
    return newsItem.photos.length !== 0;
  };

  function getAlignmentClass() {
    return newsItem.alignCenter ? "news-detail__paragraphs-center" : "news-detail__paragraphs-left";
  }

  function getMainImageUrl() {
    return newsItem.mainImg.includes("_empty") ? '' : newsItem.mainImg;
  };

  return (
    <div className="container">
      <div className="row row-cols-1 justify-content-center news-detail">
        <div className="news-detail__title">
          <h3>{newsItem.title}</h3>
          <time className="news-detail__date">{getFullDate(newsItem.date)}</time>
        </div>
        <div className="news-detail__image-wrapper">
          {
            hasPhotos()
              ? <ImageGallery items={getGalleryItems()} showThumbnails={false} lazyLoad={true} />
              : <img className="news-detail__image" src={getMainImageUrl()} alt="" />
          }
        </div>
        <div className={getAlignmentClass()}>
          {newsItem.paragraphs.map((item, index) => (
            <p key={index}>{item}</p>
          ))
          }
        </div>
        {newsItem.videos.map((item, index) => (
          <iframe key={index} className="news-detail__video" src={item} height="442" width="786" title={"Information_" + index}></iframe>
        ))
        }
      </div>
    </div >
  );
}

export default NewsDetail;